import React from 'react';
import { useState } from "react";
import GridFillIcon from 'remixicon-react/GridFillIcon';

export default function GridButton(props) {
    const [isHover, setIsHover] = useState(false);

    const wrapper ={
        width:40,
        height:40,
        borderRadius:'50%',
        backgroundColor: isHover ? 'rgba(192,192,192,0.5)' : 'transparent',
    };

    const icon = {
        fontSize:28,
        marginTop:4,
        marginLeft:4,
        color:'white'
      }

    const mouseEnter = () => {
        setIsHover(true);
    };

    const mouseLeave = () => {
        setIsHover(false);
    };
    
    return(
        <div 
            id = "gridButton"
            style={Object.assign(wrapper,props.style)} 
            onClick={props.onSelect}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            title="Grid View"
        >
            <GridFillIcon id="backIcon" style={icon} size="32px"></GridFillIcon>
        </div>

    )
}